import setupQ2Elements from './elements';
import setupQ2Outlets from './outlets';
import setupQ2Styles from './styles';
import setupAnalytics from './analytics';
import SDKMessageBus from '../utility/message-bus';
import setupGlobalVars from './global-vars';
import { IDict } from '../types/utility';

export default function setup(
    messageBus: SDKMessageBus,
    moduleInstanceId: string,
    loc: (key: string, substitutions?: string[], options?: IDict<any>) => string,
    capabilities: Set<string>,
    teardowns: (() => void)[],
    resizeIframe: () => void
): Promise<() => void> {
    const elementsProm = setupQ2Elements(loc, resizeIframe, teardowns);
    const stylesProm = setupQ2Styles(messageBus, moduleInstanceId, resizeIframe);
    const varsProm = setupGlobalVars(messageBus, capabilities);
    return Promise.all([stylesProm, varsProm, elementsProm]).then(([styleResult]) => {
        setupQ2Outlets(messageBus, moduleInstanceId, loc);
        setupAnalytics(messageBus, moduleInstanceId, capabilities);
        return function() {
            styleResult();
        };
    });
}
